export enum OverlayColors {
    tertiary = 'tertiary',
    background = 'background',
}
